import React from 'react';
import classes from './EmptyPlaceholder.module.scss';
import classNames from 'classnames';
import { WithChildren } from '../../../models/children-props';
import { IconsEnum } from '../../../constants/icons';
import { Button } from '../../actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';

export type EmptyPlaceholderWithButtonProps = {
  buttonTitle: string;
  buttonIcon?: IconsEnum;
  buttonAction: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
};

export type EmptyPlaceholderNoButtonProps = {
  buttonTitle?: false | undefined;
  buttonIcon?: undefined;
  buttonAction?: undefined;
};

export type EmptyPlaceholderViewProps = WithChildren &
  (EmptyPlaceholderWithButtonProps | EmptyPlaceholderNoButtonProps) & {
    title: string;
    image: string;
    bottomText?: string | JSX.Element;
    removeSpacings?: boolean;
    removeBorder?: boolean;
    removeTopMargin?: boolean;
  };

export const EmptyPlaceholderView = (props: EmptyPlaceholderViewProps): JSX.Element => {
  const { title, image, children, buttonTitle, buttonAction, buttonIcon, bottomText, removeBorder, removeSpacings, removeTopMargin } =
    props;
  const emptyPlaceholderClasses = classNames(classes.EmptyPlaceholder, {
    [classes.BorderPlaceholder]: !removeBorder,
    [classes.RemoveSpacings]: removeSpacings,
    [classes.RemoveTopMargin]: removeTopMargin
  });

  const buttonWrapperClasses = classNames(classes.ButtonWrapper);

  return (
    <div className={emptyPlaceholderClasses}>
      <div className={classes.ContentWrapper}>
        <div className={classes.ContentImageWrapper}>
          <div className={classes.ImageContainer}>
            <img className={classes.ImgPlaceholder} src={image} alt={title} />
          </div>
        </div>
        <h3 className={'margin-top-small-16 margin-top-large-32'}>{title}</h3>
        <div className={'margin-top-small-16 margin-top-large-32'}>
          <div className={classes.ChildrenText}>{children}</div>
          {buttonTitle && (
            <div className={buttonWrapperClasses}>
              <Button
                type={'button'}
                variant={'solid'}
                size={'medium'}
                color={ButtonColorsEnum.secondary}
                action={buttonAction}
                icon={
                  buttonIcon
                    ? {
                        value: buttonIcon,
                        side: 'left'
                      }
                    : undefined
                }>
                {buttonTitle}
              </Button>
            </div>
          )}
          <span>{bottomText}</span>
        </div>
      </div>
    </div>
  );
};
